/**
 * Fred Olsen Cruise Lines Dynamica LTT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KPIDetails } from './kPIDetails';
import { DepartureDetails } from './departureDetails';
import { Header } from './header';
import { BookingCurvesData } from './bookingCurvesData';
import { PricingCurve } from './pricingCurve';
import { RecommendationDetails } from './recommendationDetails';


export interface PopupDetails { 
    header?: Header;
    departureDetails?: DepartureDetails;
    kpiDetails?: KPIDetails;
    recommendationDetails?: RecommendationDetails;
    bookingCurvesData?: BookingCurvesData;
    pricingCurves?: Array<PricingCurve>;
}

